<template>
  <div class="wrap">
    <JNav :title="$t('newAdd.helpCenter')" />
    <div class="cont">
      <div v-html="conent"></div>
    </div>
  </div>
</template>
<script>
import JNav from "@/components/JNav";
import { GET_OTHER_ABOUT } from "@/api"
export default {
  components: {
    JNav
  },
  data() {
    return {
      conent: ''
    }
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      try {
        const res = await GET_OTHER_ABOUT({ act: 'help' })
        console.log(res);
        this.conent = res.data
      } catch (error) { }
    }
  }
}
</script>
<style scoped lang="less">
.wrap {
  min-height: 100vh;
  background-color: var(--bg);

  .cont {
    margin: calc(20rem / 16);
    background-color: var(--navBg);
    padding: 12px;
    border-radius: 10px;
    color: var(--light);
    /deep/ img{
      width: 100%;
    }
  }
}
</style>